export default __webpack_public_path__ + "static/media/dpWorldTourChampionship-light.69e23537.svg";